<template>
  <fragment>
    <div
      class="card-on-card card-outline-secondary"
      v-if="isLayoutBook === true"
    >
      <div class="card-header">
        <h5 class="mb-2 font-weight-bold">Spesifikasi</h5>
      </div>
      <div class="card-body">
        <div class="row">
          <div class="col-12">
            <div class="form-row mb-4 mb-4">
              <label class="col-md col-form-label" for="name"
                >Jumlah Halaman</label
              >
              <div class="col-lg-4">
                <input
                  type="number"
                  max="999999999999"
                  maxlength="20"
                  oninput="this.value=this.value.slice(0,this.maxLength||1/1);
                              this.value=(this.value   < 0) ? (1/1) : this.value;"
                  class="form-control"
                  :value="sectionSpecInformation.pages"
                  id="pages"
                />
                <span class="help-block with-errors"></span>
              </div>
              <label class="col-md col-form-label" for="name">Kertas Isi</label>
              <div class="col-lg-4">
                <select
                  class="form-control custom-select"
                  name="kertas_isi"
                  id="kertas_isi"
                >
                  <option
                    :value="contentPaper.value"
                    v-for="(
                      contentPaper, index
                    ) in sectionSpecInformation.contentPaper"
                    :key="index"
                    :selected="contentPaper.isSelected"
                  >
                    {{ contentPaper.name }}
                  </option>
                </select>
                <span class="help-block with-errors"></span>
              </div>
            </div>

            <div class="form-row mb-4">
              <label class="col-md col-form-label" for="name">Berat (Kg)</label>
              <div class="col-lg-4">
                <input
                  type="number"
                  class="form-control"
                  :value="sectionSpecInformation.weight"
                  id="productWeight"
                  name="productWeight"
                  @keyup="validateNotNullWeight('productWeight')"
                  step="0.1"
                  onkeypress="return (event.charCode == 8 || event.charCode == 0) ? null : event.charCode != 47 && event.charCode >= 46 && event.charCode <= 57"
                />
                <span class="invalid-feedback"
                  >Tidak boleh kosong / angka 0</span
                >
                <span class="small text-muted"
                  >Gunakan tanda . untuk menuliskan tiitk (misal: 0.200)</span
                >
              </div>
              <label class="col-md col-form-label" for="name"
                >Kertas Cover</label
              >
              <div class="col-lg-4">
                <select
                  class="form-control custom-select"
                  name="coverPaper"
                  id="coverPaper"
                >
                  <option
                    :value="coverPaper.value"
                    v-for="(
                      coverPaper, index
                    ) in sectionSpecInformation.coverPaper"
                    :key="index"
                    :selected="coverPaper.isSelected"
                  >
                    {{ coverPaper.name }}
                  </option>
                </select>
                <span class="help-block with-errors"></span>
              </div>
            </div>

            <div class="form-row mb-4">
              <label class="col-md col-form-label" for="name">Dimensi</label>
              <div class="col-md-4">
                <div class="input-group mb-3">
                  <span class="input-group-text">P</span>
                  <input
                    type="number"
                    name="productLength"
                    id="productLength"
                    class="form-control"
                    step="0.1"
                    onkeypress="return (event.charCode == 8 || event.charCode == 0) ? null : event.charCode != 47 && event.charCode >= 46 && event.charCode <= 57"
                    placeholder="0"
                    aria-label="Username"
                    :value="specDimension.long"
                  />
                  <span class="input-group-text">L</span>
                  <input
                    type="number"
                    name="productWidth"
                    id="productWidth"
                    class="form-control"
                    step="0.1"
                    onkeypress="return (event.charCode == 8 || event.charCode == 0) ? null : event.charCode != 47 && event.charCode >= 46 && event.charCode <= 57"
                    placeholder="0"
                    aria-label="Server"
                    :value="specDimension.wide"
                  />
                  <span class="input-group-text">T</span>
                  <input
                    type="number"
                    name="productHeight"
                    id="productHeight"
                    step="0.1"
                    onkeypress="return (event.charCode == 8 || event.charCode == 0) ? null : event.charCode != 47 && event.charCode >= 46 && event.charCode <= 57"
                    class="form-control"
                    placeholder="0"
                    aria-label="Server"
                    :value="specDimension.high"
                  />
                </div>
                <span class="help-block with-errors"></span>
              </div>
              <label class="col-md-2 col-form-label" for="name"
                >Warna Isi</label
              >
              <div class="col-lg-4">
                <select
                  class="form-control custom-select"
                  name="productMonitor"
                  id="productMonitor"
                >
                  <option
                    :value="fillColor.value"
                    v-for="(
                      fillColor, index
                    ) in sectionSpecInformation.fillColor"
                    :key="index"
                    :selected="fillColor.isSelected"
                  >
                    {{ fillColor.name }}
                  </option>
                </select>
                <span class="help-block with-errors"></span>
              </div>
            </div>

            <div class="form-row mb-4">
              <label class="col-md col-form-label" for="name">Kondisi</label>
              <div class="col-lg-4">
                <select
                  class="form-control custom-select"
                  name="productCondition"
                  id="productCondition"
                >
                  <option
                    :value="condition.value"
                    v-for="(
                      condition, index
                    ) in sectionSpecInformation.condition"
                    :key="index"
                    :selected="condition.isSelected"
                  >
                    {{ condition.name }}
                  </option>
                </select>
              </div>
              <label class="col-md col-form-label" for="name"
                >Warna Cover</label
              >
              <div class="col-lg-4">
                <select
                  class="form-control custom-select"
                  name="cd_dvd"
                  id="cd_dvd"
                >
                  <option
                    :value="coverColor.value"
                    v-for="(
                      coverColor, index
                    ) in sectionSpecInformation.coverColor"
                    :key="index"
                    :selected="coverColor.isSelected"
                  >
                    {{ coverColor.name }}
                  </option>
                </select>
                <span class="help-block with-errors"></span>
              </div>
            </div>

            <div class="form-row mb-4">
              <label class="col-md col-form-label" for="name">Status</label>
              <div class="col-lg-4">
                <select
                  class="form-control custom-select"
                  name="productStatus"
                  id="productStatus"
                  :disabled="isWaitingConfirm"
                >
                  <option
                    :value="status.value"
                    v-for="(status, index) in sectionSpecInformation.status"
                    :key="index"
                    :selected="status.isSelected"
                  >
                    {{ status.name }}
                  </option>
                </select>
                <span class="help-block with-errors"></span>
              </div>
              <label class="col-md col-form-label" for="name">Finishing</label>
              <div class="col-lg-4">
                <select
                  class="form-control custom-select"
                  name="finishing"
                  id="finishing"
                >
                  <option
                    :value="finishing.value"
                    v-for="(
                      finishing, index
                    ) in sectionSpecInformation.finishing"
                    :key="index"
                    :selected="finishing.isSelected"
                  >
                    {{ finishing.name }}
                  </option>
                </select>
                <span class="help-block with-errors"></span>
              </div>
            </div>

            <div class="form-row mb-4 mb-4">
              <label class="col-md col-form-label" for="name"
                >Penjilidan
              </label>
              <div class="col-lg-4">
                <select class="form-control custom-select" name="os" id="os">
                  <option
                    :value="binding.value"
                    v-for="(binding, index) in sectionSpecInformation.binding"
                    :key="index"
                    :selected="binding.isSelected"
                  >
                    {{ binding.name }}
                  </option>
                </select>
                <span class="help-block with-errors"></span>
              </div>
              <label class="col-md col-form-label" for="name"></label>
              <div class="col-lg-4">
                <input
                  class="form-control"
                  type="hidden"
                  name=""
                  id=""
                  value=""
                />
                <span class="help-block with-errors"></span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="card-on-card card-outline-secondary" v-else>
      <div class="card-header">
        <h5 class="mb-2 font-weight-bold"><b> Spesifikasi</b></h5>
      </div>
      <div class="card-body">
        <div class="row">
          <div class="col-12">
            <div
              :hidden="isLayoutService"
              class="form-row mb-4 mb-4"
            >
              <label class="col-md col-form-label" for="name">Kondisi</label>
              <div class="col-lg-4">
                <select
                  class="form-control custom-select"
                  name="productCondition"
                  id="productCondition"
                >
                  <option
                    :value="condition.value"
                    v-for="(
                      condition, index
                    ) in sectionSpecInformation.condition"
                    :key="index"
                    :selected="condition.isSelected"
                  >
                    {{ condition.name }}
                  </option>
                </select>
                <span class="help-block with-errors"></span>
              </div>
              <label class="col-md col-form-label" for="name">Processor</label>
              <div class="col-lg-4">
                <select
                  class="form-control custom-select"
                  name="productProcessor"
                  id="productProcessor"
                >
                  <option
                    :value="processor.value"
                    v-for="(
                      processor, index
                    ) in sectionSpecInformation.processor"
                    :key="index"
                    :selected="processor.isSelected"
                  >
                    {{ processor.name }}
                  </option>
                </select>
                <span class="help-block with-errors"></span>
              </div>
            </div>

            <div
              :hidden="isLayoutService"
              class="form-row mb-4"
            >
              <label
                :hidden="isLayoutService"
                class="col-md col-form-label"
                for="name"
                >Stok</label
              >
              <div class="col-lg-4">
                <input
                  type="text"
                  class="form-control"
                  :hidden="isLayoutService"
                  :value="
                    isLayoutService
                      ? 100000000
                      : sectionSpecInformation.stock
                  "
                  id="productStock"
                  name="productStock"
                  :readonly="isLayoutService"
                />
                <span class="help-block with-errors"></span>
              </div>
              <label class="col-md col-form-label" for="name"
                >Memory / RAM</label
              >
              <div
                :hidden="isLayoutService"
                class="col-lg-4"
              >
                <select
                  class="form-control custom-select"
                  name="productMemory"
                  id="productMemory"
                >
                  <option
                    :value="memory.value"
                    v-for="(memory, index) in sectionSpecInformation.memory"
                    :key="index"
                    :selected="memory.isSelected"
                  >
                    {{ memory.name }}
                  </option>
                </select>
                <span class="help-block with-errors"></span>
              </div>
            </div>

            <div
              :hidden="isLayoutService"
              class="form-row mb-4"
            >
              <label class="col-md col-form-label" for="name">Garansi</label>
              <div class="col-lg-4">
                <select
                  class="form-control custom-select"
                  name="garansi"
                  id="garansi"
                >
                  <option
                    :value="warranty.value"
                    v-for="(warranty, index) in sectionSpecInformation.warranty"
                    :key="index"
                    :selected="warranty.isSelected"
                  >
                    {{ warranty.name }}
                  </option>
                </select>
                <span class="help-block with-errors"></span>
              </div>
              <label class="col-md col-form-label" for="name">Hard Disk</label>
              <div class="col-lg-4">
                <select
                  class="form-control custom-select"
                  name="productHarddisk"
                  id="productHarddisk"
                >
                  <option
                    :value="harddisk.value"
                    v-for="(harddisk, index) in sectionSpecInformation.harddisk"
                    :key="index"
                    :selected="harddisk.isSelected"
                  >
                    {{ harddisk.name }}
                  </option>
                </select>
                <span class="help-block with-errors"></span>
              </div>
            </div>

            <div
              :hidden="isLayoutService"
              class="form-row mb-4"
            >
              <label class="col-md col-form-label" for="name">Berat (Kg)</label>
              <div class="col-lg-4">
                <input
                  type="number"
                  name="productWeight"
                  id="productWeight"
                  class="form-control"
                  :value="sectionSpecInformation.weight"
                  @keyup="validateNotNullWeight('productWeight')"
                  step="0.1"
                  onkeypress="return (event.charCode == 8 || event.charCode == 0) ? null : event.charCode != 47 && event.charCode >= 46 && event.charCode <= 57"
                />
                <span class="invalid-feedback"
                  >Tidak boleh kosong / angka 0</span
                >
                <span class="small text-muted"
                  >Gunakan tanda . untuk menuliskan titik (misal: 0.200)</span
                >
              </div>
              <label class="col-md col-form-label" for="name">DVD/CD</label>
              <div class="col-lg-4">
                <select
                  class="form-control custom-select"
                  name="productMediaPlayer"
                  id="productMediaPlayer"
                >
                  <option
                    :value="cdDvd.value"
                    v-for="(cdDvd, index) in sectionSpecInformation.cdDvd"
                    :key="index"
                    :selected="cdDvd.isSelected"
                  >
                    {{ cdDvd.name }}
                  </option>
                </select>
                <span class="help-block with-errors"></span>
              </div>
            </div>

            <div
              :hidden="isLayoutService"
              class="form-row mb-4"
            >
              <label class="col-md col-form-label" for="name">Dimensi</label>
              <div class="col-md-4">
                <div class="input-group mb-3">
                  <span class="input-group-text">P</span>
                  <input
                    type="text"
                    name="productLength"
                    id="productLength"
                    class="form-control"
                    placeholder="0"
                    aria-label="Username"
                    :value="sectionSpecInformation.dimension.long"
                    step="0.1"
                    onkeypress="return (event.charCode == 8 || event.charCode == 0) ? null : event.charCode != 47 && event.charCode >= 46 && event.charCode <= 57"
                  />
                  <span class="input-group-text">L</span>
                  <input
                    type="text"
                    name="productWidth"
                    id="productWidth"
                    class="form-control"
                    placeholder="0"
                    aria-label="Server"
                    :value="sectionSpecInformation.dimension.wide"
                    step="0.1"
                    onkeypress="return (event.charCode == 8 || event.charCode == 0) ? null : event.charCode != 47 && event.charCode >= 46 && event.charCode <= 57"
                  />
                  <span class="input-group-text">T</span>
                  <input
                    type="text"
                    name="productHeight"
                    id="productHeight"
                    class="form-control"
                    placeholder="0"
                    aria-label="Server"
                    :value="sectionSpecInformation.dimension.high"
                    step="0.1"
                    onkeypress="return (event.charCode == 8 || event.charCode == 0) ? null : event.charCode != 47 && event.charCode >= 46 && event.charCode <= 57"
                  />
                </div>
                <span class="help-block with-errors"></span>
              </div>
              <label class="col-md-2 col-form-label" for="name">Monitor</label>
              <div class="col-lg-4">
                <select
                  class="form-control custom-select"
                  name="productMonitor"
                  id="productMonitor"
                >
                  <option
                    :value="monitor.value"
                    v-for="(monitor, index) in sectionSpecInformation.monitor"
                    :key="index"
                    :selected="monitor.isSelected"
                  >
                    {{ monitor.name }}
                  </option>
                </select>
                <span class="help-block with-errors"></span>
              </div>
            </div>

            <div class="form-row mb-4">
              <label class="col-md-2 col-form-label" for="name">Status</label>
              <div class="col-lg-4">
                <select
                  class="form-control custom-select"
                  name="productStatus"
                  id="productStatus"
                  :disabled="isWaitingConfirm"
                >
                  <option
                    :value="status.value"
                    v-for="(status, index) in sectionSpecInformation.status"
                    :key="index"
                    :selected="status.isSelected"
                  >
                    {{ status.name }}
                  </option>
                </select>
                <p class="badge badge-soft-warning mt-2" v-show="isWaitingConfirm">
                  Status produk masih menunggu konfirmasi dari Mitra
                </p>
                <span class="help-block with-errors"></span>
              </div>
              <!-- <div class="col-lg-4"></div> -->
              <label
                :hidden="isLayoutService"
                class="col-md col-form-label"
                for="name"
                >OS</label
              >
              <div
                :hidden="isLayoutService"
                class="col-lg-4"
              >
                <select
                  class="form-control custom-select"
                  name="productOs"
                  id="productOs"
                >
                  <option
                    :value="os.value"
                    v-for="(os, index) in sectionSpecInformation.os"
                    :key="index"
                    :selected="os.isSelected"
                  >
                    {{ os.name }}
                  </option>
                </select>
                <span class="help-block with-errors"></span>
              </div>
            </div>

            <div
              :hidden="isLayoutService"
              class="form-row mb-4 mb-4"
            >
              <label class="col-md col-form-label" for="name"
                >Aplikasi Terpasang
              </label>
              <div class="col-lg-4">
                <input
                  class="form-control"
                  type="text"
                  name="productApplication"
                  id="productApplication"
                  :value="sectionSpecInformation.installedApplication"
                  placeholder="contoh: Ms.Office, Adobe CS, AntiVirus"
                />
                <span class="help-block with-errors"></span>
              </div>
              <label class="col-md col-form-label" for="name"
                >Tipe Produk</label
              >
              <div class="col-lg-4">
                <select
                  class="form-control custom-select"
                  name="productType"
                  id="productType"
                >
                  <option>Ready</option>
                  <option>Pre Order</option>
                </select>
                <span class="help-block with-errors"></span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </fragment>
</template>
 
<script>
// import axios from "axios";
import $ from "jquery";

export default {
  props: {
    sectionProductInformation: {},
    sectionSpecInformation: {},
    specDimension: {},
    isLayoutBook: Boolean,
    isLayoutService:Boolean,
    isWaitingConfirm:Boolean,
    isBlocked:Boolean
  },
  methods: {
    validateNotNullWeight(idEl) {
      let element = $(`#${idEl}`);

      if (element.val() === "") {
        element.addClass("is-invalid");
      } else if (element.val() == 0 && element.val() !== "") {
        element.addClass("is-invalid");
      } else {
        element.removeClass("is-invalid");
      }
    },
  },
};
</script>